import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text, Divider } from 'components/ui';
import LegacyGrid from 'components/LegacyGrid/LegacyGrid';
import localeUtils from 'utils/LanguageLocale';
import AccountNicknameEN from './locales/AccountNickname_en_US';
import AccountNicknameFR from './locales/AccountNickname_fr_CA';

const { getLocalisedDataFromResource } = localeUtils;

const AccountNickname = function ({ user }) {
    const getText = getLocalisedDataFromResource(AccountNicknameEN, AccountNicknameFR);

    // Only show nickname section if user has a nickname
    if (!user.nickName) {
        return null;
    }

    return (
        <React.Fragment>
            <LegacyGrid
                gutter={3}
                data-at={Sephora.debug.dataAt('account_nickname_field')}
                alignItems='baseline'
            >
                <LegacyGrid.Cell
                    width={Sephora.isMobile() ? 85 : 1 / 4}
                    fontWeight='bold'
                >
                    {getText('nickname')}
                </LegacyGrid.Cell>
                <LegacyGrid.Cell width='fill'>
                    <Text
                        is='p'
                        marginBottom='.5em'
                    >
                        {user.nickName}
                    </Text>
                    <Text is='p'>
                        {getText('nicknameDescription')}
                    </Text>
                </LegacyGrid.Cell>
            </LegacyGrid>
            <Divider marginY={5} />
        </React.Fragment>
    );
};

export default wrapFunctionalComponent(AccountNickname);
